const AIR_DUCT_IMG = 'https://static.readdy.ai/image/d21c811a591cac7dc9306c593ec79059/764a64978b82d3d638254afb23db1b32.png';

const DRYER_VENT_IMG = 'https://static.readdy.ai/image/d21c811a591cac7dc9306c593ec79059/acfff023ef35eb90fcd0daa016da6c90.png';

export default function ServiceSection() {
  return (
    <section className="bg-[#f5f7fa] py-14">
      <div className="max-w-6xl mx-auto px-4 space-y-16">
        {/* Air Duct Cleaning */}
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="space-y-4">
            <h4 className="text-2xl font-bold text-[#2E7DD1]">
              <a href="#booking-form" className="hover:text-[#3B8FE8] transition-colors">
                Air Duct Cleaning
              </a>
            </h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              Our air duct cleaning service uses a professional negative air machine with true HEPA filtration to fully remove dust, debris, and airborne contaminants from your duct system. This process creates strong negative pressure inside the ducts, allowing buildup to be safely pulled out rather than pushed around. As specialized tools loosen dust, allergens, and particles from inside the system, the negative air machine immediately extracts them and captures everything through sealed HEPA filtration. This prevents contaminants from being released back into your home during the cleaning process. The result is a deeper, containment-based cleaning designed to improve air quality, reduce circulating dust, and support healthier airflow throughout the home.
            </p>
            <a
              href="#booking-form"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#2E7DD1] hover:text-[#3B8FE8] transition-colors cursor-pointer"
            >
              Schedule Now <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="w-full aspect-square rounded-xl overflow-hidden shadow-lg">
            <img
              src={AIR_DUCT_IMG}
              alt="Professional air duct cleaning service technician working on residential HVAC system"
              title="air duct cleaning service near me"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Dryer Vent Cleaning */}
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="w-full aspect-square rounded-xl overflow-hidden shadow-lg order-2 lg:order-1">
            <img
              src={DRYER_VENT_IMG}
              alt="Professional dryer vent cleaning service removing lint buildup for fire prevention"
              title="dryer vent cleaning service fire prevention"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="space-y-4 order-1 lg:order-2">
            <h4 className="text-2xl font-bold text-[#2E7DD1]">
              <a href="#booking-form" className="hover:text-[#3B8FE8] transition-colors">
                Dryer Vent Cleaning
              </a>
            </h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              Protect your home from <strong>fire hazards</strong> with our expert <strong>dryer vent cleaning</strong> services. Our certified technicians specialize in thorough dryer duct cleaning that removes dangerous lint buildup and improves your appliance&apos;s efficiency. Don&apos;t risk a preventable fire — schedule your professional dryer vent cleaning today and enjoy lower energy bills, faster drying times, and complete peace of mind.
            </p>
            <a
              href="#booking-form"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#2E7DD1] hover:text-[#3B8FE8] transition-colors cursor-pointer"
            >
              Schedule Now <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
